import axios from "axios";

export default axios.create({
  baseURL: "https://gearbest-database.onrender.com",
});
